<script>
    import { defaults } from "../file_variables"
</script>

<div class="bx--bio">
    {@html defaults.bio}
</div>